import React, { useEffect } from 'react'
import { BlueBorderButton, BlueButton, CancelButton } from '../../components/buttoncomponents'
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Card, Row, Col, Accordion } from "react-bootstrap";
import Moment from "moment"
import * as FormFields from "../../components/formcomponents";
import { useFormik } from 'formik'
import { border } from '@mui/system';
import * as CONFIG from "../../helpers/config"
import axios from "axios"
import { useMsal } from "@azure/msal-react";

export default function C_list(props) {
    const { instance } = useMsal();
    console.log(props)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [achievementModal, setAchievementModal] = useState(false)
    const [doc, setDoc] = useState(false)
    const [key, setKey] = useState(0)
    const [achievementlist, setAchievementList] = useState([])
    const [employmentHistory, setEmploymentHisotry] = useState([])

    const formik = useFormik({
        initialValues: {
            contactkey: props.data.key,
            key: 0,
            achievementDate: false,
            note: '',
            experience: ''
        }
    })

    useEffect(() => {
        const json_list = {
            "instanceID": CONFIG.PMSInstanceID,
            "accountSubscriptionID": CONFIG.AccountSubscriptionID,
            "created_User": CONFIG.LoginID,
            "ID": props.data.financialInstituteContactID
            // FinancialInstitutionContactID
        }

        axios.post(CONFIG.TMS_SERVER_URL + CONFIG.GET_FINANCIAL_CONTACT_HISTORY, json_list, { headers: { "Authorization": `Bearer ${CONFIG.AuthToken}`, "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
            .then((res) => {
                console.log(res.data.result)
                setEmploymentHisotry(res.data.result)
            }).catch((error) => {
                if (error.response.status == 401) {
                    localStorage.clear();
                    instance.logoutRedirect({
                        postLogoutRedirectUri: "/",
                    });
                }
            })

        if(props.isContact == true ){
            if(props.financecontactID == props.data.financialInstituteContactID){
                console.log('inside if of is contacrt')
                toggle()
            }
        }
    }, [])

    useEffect(() => {
        if (props.data.contactAchievements != null) {
            console.log('inside use effect')
            let newkey = 0
            props.data.contactAchievements.map((ach,k)=>{
                ach.key = k
                newkey = k
            })
            console.log(props.data.contactAchievements)
            setKey(newkey++)
            setAchievementList(props.data.contactAchievements)
        }
    }, [props])
    const toggle = () => {
        setIsModalOpen(!isModalOpen)
    }
    const editContact = () => {
        toggle()
        props.editContact(props.data)
    }
    const openAddAchievement = () => {
        formik.values.achievementDate = false
        setAchievementModal(!achievementModal)
    }
    const handleAchievementDate = (date) => {
        formik.values.achievementDate = date
        setDoc(!doc)
    }
    const saveAchievement = () => {
        console.log('inside save Achievements')
        let k = key
        let list = {
            "achievementDate": formik.values.achievementDate,
            "note": formik.values.note,
            "experience": formik.values.experience,
            "key": k,
            "contactkey": props.data.key
        }
        let alist = [...achievementlist]
        k++
        alist.push(list)
        setAchievementList(alist)
        setKey(k)
        achtoggle()
        props.data.contactAchievements = alist
        props.saveAchievement(props.data)
    }
    const achtoggle = () => {
        setAchievementModal(!achievementModal)
    }
    const deleteAchievement = (e)=>{
        let key = e.target.id
        console.log(key)
    }
    return (
        <>
            <Modal isOpen={isModalOpen} toggle={toggle} className="modal-dialog-custom-width trade_existing_customer">

                <Modal isOpen={achievementModal} toggle={achtoggle} className='mt-10-rem property_info_modal mt-5'>
                    <ModalHeader toggle={achtoggle}>
                        <div className='font-16 font-weight-600 color-707895'>Achievements</div>
                    </ModalHeader>
                    <ModalBody className=''>
                        <Row className='d-flex plr-2-rem align-items-center justify-content-center'>
                            <FormFields.DatePick
                                md={10}
                                label='Date'
                                classname='pt-1-rem iconDatePicker'
                                val={formik.values.achievementDate}
                                handleCompletionDate={handleAchievementDate}
                            />
                            <FormFields.inputFieldArea
                                md={10}
                                name='note'
                                label='Write a note... eg: interests'
                                classname='pt-1-rem'
                                type='text'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <Col md={10} className='mt-1-rem'>
                                <div className='font-12 font-400'>How's the experience?</div>
                                <div>
                                    <Row className='d-flex justify-content-between'>
                                        <Col md={3} className='achievement_badge font-12 d-flex align-items-center justify-content-center pointer' onClick={() => {
                                            formik.values.experience = 'Excellent'
                                            setDoc(!doc)
                                        }} style={formik.values.experience == 'Excellent' ? { border: '1px solid #919296' } : {}}>
                                            Excellent
                                        </Col>
                                        <Col md={3} className='achievement_badge font-12 d-flex align-items-center justify-content-center pointer' onClick={() => {
                                            formik.values.experience = 'Good'
                                            setDoc(!doc)
                                        }} style={formik.values.experience == 'Good' ? { border: '1px solid #919296' } : {}}>
                                            Good
                                        </Col>
                                        <Col md={3} className='achievement_badge font-12 d-flex align-items-center justify-content-center pointer' onClick={() => {
                                            formik.values.experience = 'Not Good'
                                            setDoc(!doc)
                                        }} style={formik.values.experience == 'Not Good' ? { border: '1px solid #919296' } : {}}>
                                            Not Good
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className='d-flex justify-content-end' >
                        <BlueBorderButton value='Cancel' clickEvent={achtoggle} />
                        <BlueButton value='Submit' clickEvent={saveAchievement} />
                    </ModalFooter>
                </Modal>
                <ModalBody className='service-request-modal-wrapper mx-3'>
                    <div className='service-request-detail-title d-flex justify-content-between mx-4 mt-1-rem '>
                        <div><h4 class="font-16 text-uppercase font-weight-600 color-707895">CONTACT DETAILS</h4></div>
                        <BlueBorderButton value='Edit' clickEvent={editContact} />

                    </div>
                    <div className='bb-ficontact mt-1-rem mx-4'></div>
                    <div className=''>
                        <div className='mx-4 br-8'>

                            <div className='br-8 py-3' style={{ overflowY: 'scroll', height: '70vh', paddingRight: '20px' }}>
                                <Tabs>
                                    <Card className='tabs-wrap-profile'>
                                        <TabList>
                                            <Tab>Current Profile</Tab>
                                            {props.isEdit == true &&
                                                <Tab>Employment History</Tab>
                                            }
                                        </TabList>
                                    </Card>
                                    <TabPanel className='mt-1-rem'>
                                        <div className='rounded_border_tabs' style={{ padding: '3%' }}>
                                            <Row>
                                                <Col md={3}>
                                                    <div className='font-16 font-weight-600'>{props.data.fullName}</div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className='font-13 font-weight-400'>Designation</div>
                                                    <div className='font-14 font-weight-600'>{props.data.designation}</div>
                                                </Col>
                                                <Col md={6} className=''>
                                                    <div className='font-13 font-weight-400'>Email ID & Mobile No</div>
                                                    <div className='font-14 font-weight-600'>{props.data.email} <span className='mx-3 font-weight-400 brd-color'>|</span>{props.data.mobileNo}</div>
                                                </Col>

                                            </Row>
                                            <Row className='mt-2-rem'>
                                                <Col md={3}>
                                                    <div className='font-13 font-weight-400'>Institute Name</div>
                                                    <div className='font-14 font-weight-600'>{props.insituteData.bank!=null ? props.insituteData.bank.bankName: props.insituteData.bankName}</div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className='font-13 font-weight-400'>Phone No</div>
                                                    <div className='font-14 font-weight-600'>{props.data.telephoneNo}</div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className='font-13 font-weight-400'>Contact Type</div>
                                                    <div className='font-14 font-weight-600'>{(props.data.contactType && props.data.contactType != null) ? props.data.contactType.contactTypeName: props.data.contactTypeName}</div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className='font-13 font-weight-400'>From</div>
                                                    <div className='font-14 font-weight-600'>{Moment(props.data.fromDate).format("DD/MM/yyyy")}</div>
                                                </Col>
                                            </Row>
                                            <Row className='mt-2-rem'>
                                                <div className='font-weight-500 font-16'>
                                                    Social Media
                                                    <Row className='mt-2'>
                                                        <Col md={1} >
                                                            <a target="_blank" href={props.data.linkedInUrl}><svg width="48" height="48" viewBox="0 0 48 46" fill="none" >
                                                                <circle cx="23" cy="22" r="22" fill="#F0F5F8" stroke="#2C67FF" stroke-width="1.5"  />
                                                                <path d="M18.1211 13.0132C18.1208 13.5436 17.9099 14.0522 17.5346 14.4271C17.1593 14.802 16.6505 15.0125 16.1201 15.0122C15.5897 15.0119 15.0811 14.801 14.7062 14.4257C14.3313 14.0505 14.1208 13.5416 14.1211 13.0112C14.1214 12.4808 14.3323 11.9722 14.7076 11.5973C15.0828 11.2224 15.5917 11.0119 16.1221 11.0122C16.6525 11.0125 17.1611 11.2234 17.536 11.5987C17.9109 11.974 18.1214 12.4828 18.1211 13.0132ZM18.1811 16.4932H14.1811V29.0132H18.1811V16.4932ZM24.5011 16.4932H20.5211V29.0132H24.4611V22.4432C24.4611 18.7832 29.2311 18.4432 29.2311 22.4432V29.0132H33.1811V21.0832C33.1811 14.9132 26.1211 15.1432 24.4611 18.1732L24.5011 16.4932Z" fill="#2C67FF" />
                                                            </svg></a>
                                                        </Col>
                                                        <Col md={1}>
                                                            <a target="_blank" href={props.data.facebookUrl}><svg width="48" height="48" viewBox="0 0 46 46" fill="none">
                                                                <circle cx="22" cy="22" r="22" fill="#F0F5F8" />
                                                                <path d="M24.5391 23.9155H27.0391L28.0391 19.9155H24.5391V17.9155C24.5391 16.8855 24.5391 15.9155 26.5391 15.9155H28.0391V12.5555C27.7131 12.5125 26.4821 12.4155 25.1821 12.4155C22.4671 12.4155 20.5391 14.0725 20.5391 17.1155V19.9155H17.5391V23.9155H20.5391V32.4155H24.5391V23.9155Z" fill="#2C67FF" />
                                                            </svg></a>
                                                        </Col>
                                                        <Col md={1}>
                                                            <a target="_blank" href={props.data.twitterUrl}><svg width="48" height="48" viewBox="0 0 46 46" fill="none" >
                                                                <circle cx="22" cy="22" r="22" fill="#F0F5F8" />
                                                                <path d="M32.6994 16.0715C31.936 16.4091 31.1264 16.6309 30.2974 16.7295C31.1712 16.2069 31.8251 15.3845 32.1374 14.4155C31.3174 14.9035 30.4184 15.2455 29.4814 15.4305C28.852 14.757 28.0178 14.3104 27.1084 14.16C26.199 14.0097 25.2653 14.1639 24.4527 14.5989C23.64 15.0339 22.9938 15.7251 22.6145 16.5652C22.2352 17.4054 22.1442 18.3472 22.3554 19.2445C20.6925 19.1611 19.0657 18.729 17.5807 17.9761C16.0956 17.2233 14.7855 16.1665 13.7354 14.8745C13.3637 15.5129 13.1684 16.2387 13.1694 16.9775C13.1694 18.4275 13.9074 19.7085 15.0294 20.4585C14.3654 20.4376 13.716 20.2582 13.1354 19.9355V19.9875C13.1356 20.9532 13.4698 21.8891 14.0813 22.6365C14.6927 23.384 15.5439 23.8969 16.4904 24.0885C15.874 24.2555 15.2277 24.2801 14.6004 24.1605C14.8673 24.9917 15.3874 25.7187 16.088 26.2396C16.7886 26.7605 17.6345 27.0492 18.5074 27.0655C17.6399 27.7468 16.6466 28.2504 15.5843 28.5476C14.522 28.8448 13.4115 28.9297 12.3164 28.7975C14.2281 30.0269 16.4535 30.6796 18.7264 30.6775C26.4194 30.6775 30.6264 24.3045 30.6264 18.7775C30.6264 18.5975 30.6214 18.4155 30.6134 18.2375C31.4323 17.6456 32.139 16.9125 32.7004 16.0725L32.6994 16.0715Z" fill="#2C67FF" />
                                                            </svg></a>
                                                        </Col>
                                                        <Col md={1}>
                                                            <a target="_blank" href={props.data.instagramUrl}><svg width="48" height="48" viewBox="0 0 46 46" fill="none">
                                                                <circle cx="22" cy="22" r="22" fill="#F0F5F8" />
                                                                <path d="M22.5391 12.4155C25.2561 12.4155 25.5951 12.4255 26.6611 12.4755C27.7261 12.5255 28.4511 12.6925 29.0891 12.9405C29.7491 13.1945 30.3051 13.5385 30.8611 14.0935C31.3696 14.5934 31.763 15.1981 32.0141 15.8655C32.2611 16.5025 32.4291 17.2285 32.4791 18.2935C32.5261 19.3595 32.5391 19.6985 32.5391 22.4155C32.5391 25.1325 32.5291 25.4715 32.4791 26.5375C32.4291 27.6025 32.2611 28.3275 32.0141 28.9655C31.7637 29.6333 31.3702 30.2381 30.8611 30.7375C30.361 31.2458 29.7564 31.6393 29.0891 31.8905C28.4521 32.1375 27.7261 32.3055 26.6611 32.3555C25.5951 32.4025 25.2561 32.4155 22.5391 32.4155C19.8221 32.4155 19.4831 32.4055 18.4171 32.3555C17.3521 32.3055 16.6271 32.1375 15.9891 31.8905C15.3214 31.64 14.7166 31.2465 14.2171 30.7375C13.7085 30.2377 13.315 29.633 13.0641 28.9655C12.8161 28.3285 12.6491 27.6025 12.5991 26.5375C12.5521 25.4715 12.5391 25.1325 12.5391 22.4155C12.5391 19.6985 12.5491 19.3595 12.5991 18.2935C12.6491 17.2275 12.8161 16.5035 13.0641 15.8655C13.3143 15.1977 13.7079 14.5928 14.2171 14.0935C14.7167 13.5848 15.3215 13.1913 15.9891 12.9405C16.6271 12.6925 17.3511 12.5255 18.4171 12.4755C19.4831 12.4285 19.8221 12.4155 22.5391 12.4155ZM22.5391 17.4155C21.213 17.4155 19.9412 17.9423 19.0035 18.88C18.0658 19.8177 17.5391 21.0894 17.5391 22.4155C17.5391 23.7416 18.0658 25.0134 19.0035 25.9511C19.9412 26.8887 21.213 27.4155 22.5391 27.4155C23.8651 27.4155 25.1369 26.8887 26.0746 25.9511C27.0123 25.0134 27.5391 23.7416 27.5391 22.4155C27.5391 21.0894 27.0123 19.8177 26.0746 18.88C25.1369 17.9423 23.8651 17.4155 22.5391 17.4155ZM29.0391 17.1655C29.0391 16.834 28.9074 16.5161 28.6729 16.2816C28.4385 16.0472 28.1206 15.9155 27.7891 15.9155C27.4575 15.9155 27.1396 16.0472 26.9052 16.2816C26.6708 16.5161 26.5391 16.834 26.5391 17.1655C26.5391 17.497 26.6708 17.815 26.9052 18.0494C27.1396 18.2838 27.4575 18.4155 27.7891 18.4155C28.1206 18.4155 28.4385 18.2838 28.6729 18.0494C28.9074 17.815 29.0391 17.497 29.0391 17.1655ZM22.5391 19.4155C23.3347 19.4155 24.0978 19.7316 24.6604 20.2942C25.223 20.8568 25.5391 21.6199 25.5391 22.4155C25.5391 23.2112 25.223 23.9742 24.6604 24.5368C24.0978 25.0995 23.3347 25.4155 22.5391 25.4155C21.7434 25.4155 20.9804 25.0995 20.4177 24.5368C19.8551 23.9742 19.5391 23.2112 19.5391 22.4155C19.5391 21.6199 19.8551 20.8568 20.4177 20.2942C20.9804 19.7316 21.7434 19.4155 22.5391 19.4155Z" fill="#2C67FF" />
                                                            </svg></a>
                                                        </Col>
                                                        <Col md={2}>
                                                            <div className='font-14 font-weight-500'>{props.data.externalSourceName}</div>
                                                            <div><a target="_blank" href={props.data.externalSourceUrl}>{props.data.externalSourceUrl}</a></div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Row>
                                            <Row className='mt-2-rem'>
                                                <div className='font-weight-500 font-16'>
                                                    Notes
                                                </div>
                                                <div className='font-weight-500 font-14 mt-1'>
                                                    {props.data.additionalInfo}
                                                </div>
                                            </Row>
                                        </div>
                                        {props.isEdit == true &&
                                            <div className='mt-1-rem'>
                                                <div className='d-flex justify-content-between'>
                                                    <div className='font-weight-600 font-16'>Achievements</div>
                                                    <div>
                                                        <BlueBorderButton value='Add Achievements' clickEvent={openAddAchievement} />
                                                    </div>
                                                </div>
                                                <div>
                                                    {achievementlist != null && achievementlist.length > 0 &&
                                                        achievementlist.map((list, k) => {
                                                            if(list.is_Deleted != true){
                                                                return (
                                                                    <div className='rounded_border_tabs mt-1-rem' style={{ padding: '3%' }}>
                                                                        <Row>
                                                                            <Col md={2} className='br-right'>
                                                                                {Moment(list.achievementDate).format('DD/MM/yyyy')}
                                                                            </Col>
                                                                            <Col md={4} className='font-16 font-weight-600'>
                                                                                {list.note}
                                                                            </Col>
                                                                            <Col md={2}>
                                                                                {list.experience}
                                                                            </Col>
                                                                            <Col md={1}>
                                                                                <img src='assets/images/trash.svg' className='pointer' id={list.key} onClick={deleteAchievement}/>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </TabPanel>
                                    {props.isEdit == true &&
                                        <TabPanel>
                                            <Accordion className='meeting_accordin mt-2-rem'>
                                                {employmentHistory.map((emp, k) => {
                                                    return (
                                                        <Accordion.Item eventKey={k}>
                                                            <Accordion.Header>
                                                                <span className='bgMeeting'> <img src='assets/images/meeting_task.svg' /> </span>
                                                                <div className='d-flex justify-content-between width-100l'>
                                                                    <span className='meeting_agendaname'>
                                                                        {emp.institute}
                                                                    </span>
                                                                    <span className='br-right' style={{paddingRight: '10px'}}>
                                                                        {emp.designation}
                                                                    </span>
                                                                    <span>
                                                                        {Moment(emp.duratationfromdate).format('DD/MM/yyyy') + '-' + Moment(emp.duratationtodate).format('DD/MM/yyyy')}
                                                                    </span>
                                                                </div>
                                                            </Accordion.Header>
                                                            <Accordion.Body>
                                                                <div className='font-weight-600 font-16'>Achievements</div>
                                                                {emp.achievements.map((list,k)=>{
                                                                    return(
                                                                        <div className='rounded_border_tabs mt-1-rem' style={{ padding: '3%' }}>
                                                                            <Row>
                                                                                <Col md={2} className='br-right'>
                                                                                    {Moment(list.achievementDate).format('DD/MM/yyyy')}
                                                                                </Col>
                                                                                <Col md={4} className='font-16 font-weight-600'>
                                                                                    {list.note}
                                                                                </Col>
                                                                                <Col md={2}>
                                                                                    {list.experience}
                                                                                </Col>
                                                                            </Row>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    )
                                                })}
                                            </Accordion>
                                        </TabPanel>
                                    }
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className='p-2-rem trade_existing_customer_modal_footer d-flex justify-content-start'>
                    <span><BlueBorderButton value='Back' clickEvent={toggle} /></span>
                </ModalFooter>
            </Modal>
            <tr>
                <td>
                    <div className='align-items-center d-flex py-3 font-weight-500 font-15 '> {props.data.fullName}</div>
                </td>
                <td>
                    <div className='align-items-center d-flex py-3 font-weight-400 font-15 '>  {props.data.designation} </div>
                </td>
                <td>
                    <div className='align-items-center d-flex py-3 font-weight-500 font-15 '>  {props.data.email} <span className='px-3 font-weight-400'>| </span> {props.data.mobileNo}</div>
                </td>
                <td>
                    <div className='align-items-center d-flex py-3 font-weight-400 font-15 '> {(props.data.contactType && props.data.contactType != null) ? props.data.contactType.contactTypeName: props.data.contactTypeName}</div>
                </td>
                <td>
                    <BlueButton  value='View Details' clickEvent={toggle} />
                </td>
            </tr>
        </>
    )
}
